import SalePointMonitoringDocs from "../../SalePointMonitoringDocs";
import SalePointMonitoringDocsSync from "../../../utils/localDB/salePointMonitoringDocs";


class SaleDocsMonitoringDocsManager {

    async getList(params) {
        if(params.isOffline){
            return await new SalePointMonitoringDocsSync().getList(params)
        }
        try {
            const result = await SalePointMonitoringDocs.getList(params)
            window.postMessage('online')
            return result
        } catch (error) {
            const result = await new SalePointMonitoringDocsSync().getList(params)
            window.postMessage('offline')
            return result
        }
    }
}

export default new SaleDocsMonitoringDocsManager()